/**
 * This method  giving url.
 * * @param {String} url      The url where query string needs to be appended
 * @return {object}
 * Usage: this method will ues URL API and will return object. when URL API will throw Error in case of not valid url it will give path and queryparam
 * example : for valid URL: https://www.jcpenney.com/home?brand=adidas
 * url('https://www.jcpenney.com/home?brand=adidas') => output: 
output : {hash: "host: "www.jcpenney.com", hostname: "www.jcpenney.com"
href: "https://www.jcpenney.com/g/jewelry-and-watches?event=mothers+day&view_all=view+all+brands&id=dept20000020&boostIds=ppr5007835267-ppr5007662026-ppr5008210738"
origin: "https://www.jcpenney.com"
pathname: "/g/jewelry-and-watches"
protocol: "https:"
search: "?event=mothers+day&view_all=view+all+brands&id=dept20000020&boostIds=ppr5007835267-ppr5007662026-ppr5008210738"
searchParams: URLSearchParams {}}
 *           invalid url: /home?api:error for info visit visit MDN doc
 * addParams('https://www.jcpenney.com', { firstParam: 'test', secondParam: 'test2'})
 */
export function url(url) {
    try {
        url = new URL(url);
        return url;
    } catch {
        const urlparts = url.split('?');
        return { pathname: urlparts[0], query: urlparts };
    }
}
